$(document).ready(function () {
    $(window).on("scroll", function () {
        const scroll = $(window).scrollTop();
        const isLarge = $.mediaQuery("lg");

        $(".parallax").each(function () {
            const wrapper = $(this).find(".wrapper");

            const top = $(this).offset().top - $.constants.menuHeight;
            const height = $(this).height();
            const bottom = top + height + $.constants.menuHeight;

            const parallax = scroll > top && scroll < bottom && isLarge;

            $(wrapper)
                .css("position", parallax ? "fixed" : "static")
                .css("left", parallax ? "50%" : "auto")
                .css("top", parallax ? `${$.constants.menuHeight}px` : "auto")
                .css("transform", parallax ? "translateX(-50%)" : "none");
        });

        $(".masked").each(function () {
            const top = $(this).offset().top;
            const dist = Math.max(0, top - scroll - 200);
            $(this).toggleClass("unmasked", dist === 0);
        });
    });
});
